import React, { useContext } from 'react';
import {  useCurrentFrame, Img, staticFile } from "remotion";
import { RecruitingVideoFile } from "../components/RecruitingVideoFile";
import { Sequence, useVideoConfig, spring, AbsoluteFill } from "remotion";
import QueryStringContext from '../../components/QueryStringContext';
import { MyThumbnail } from '../components/Recruiting_Thumbnail';
import '../../App.css';
import AgentInfo from '../../components/SalesRepInfo_PreFilled';
import { TitleCard } from '../components/TitleCard';
import { UsMap } from '../components/MapVideoFile';




export const MyComposition = ({ title }) => {
  const frame = useCurrentFrame();
  
  const { fps } = useVideoConfig();
  const { f, l } = useContext(QueryStringContext);
  const F = f ? f.toUpperCase() : '';
 
  const agentInfoScale = spring({
    fps,
    frame: frame - 7120,
    from: 1,
    to: 2,
    config: {
      damping: 50,
    },
    durationInFrames: 40,
  });

  let introTitle;
  let boostBrand;
  let agentBenefit;
  let agentBold;

  if (f === 'null' || f === 'undefined' || f === '') {
    introTitle = 'The Desert North Opportunity';
    boostBrand = `HOW CAN WE BUILD YOUR BUSINESS & BRAND BIGGER THAN EVER?`;
    agentBenefit = `HOW WILL AGENTS BENEFIT?`
    agentBold = `ARE YOU BOLD ENOUGH?`
  } else {
    introTitle = `${f} ${l}'s personalized video presentation`;
    boostBrand = `HOW CAN WE BUILD ${F}'S BUSINESS & BRAND BIGGER THAN EVER?`;
    agentBenefit = `SO HOW WILL IT BENEFIT YOU ${F}?`
    agentBold = `${F}, ARE YOU BOLD ENOUGH?`
  }


  return (
    <>
      <Sequence durationInFrames={15}>
        <MyThumbnail />
        
      </Sequence>
      
      <Sequence from={14}>
        <RecruitingVideoFile />
      </Sequence>
      


      

      <Sequence from={0}>
      <TitleCard title={introTitle.toUpperCase()} BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={240}>
      <TitleCard title="WHY WOULD YOU BUILD A BUSINESS THAT'S NOT DESIGNED TO BE PROFITABLE?" BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={1738}>
      <TitleCard title="AGENTS FOR AGENTS" BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={2160}>
      <TitleCard title={boostBrand.toUpperCase()} BGcolor="#BCD400" GraphicDuration="170"/>
      </Sequence>

      <Sequence from={2930}>
      <TitleCard title="THEY SHOULDN'T...AND THEY DON'T HAVE TOO!" BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={4090} durationInFrames={250}>
        <AbsoluteFill
         style={{

          backgroundColor: 'white',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
         }}>
          <UsMap />
        </AbsoluteFill>
      </Sequence>

      <Sequence from={4000}>
      <TitleCard title="EXPAND YOUR BRAND ACROSS THE COUNTRY" BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={4320}>
      <TitleCard title={agentBenefit} BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      <Sequence from={4580}>
      <TitleCard title={`OUR PROFITS ARE PAID OUT TO OUR AGENTS`} BGcolor="#BCD400" GraphicDuration="170"/>
      </Sequence>

      <Sequence from={4820}>
      <TitleCard title={`WE BUILT OUR OWN CRM FOR LEAD GENERATION AND MANAGEMENT`} BGcolor="#BCD400" GraphicDuration="150"/>
      </Sequence>

      
      <Sequence from={5870} durationInFrames={300}>
      <AbsoluteFill>
        <Img src={staticFile('Website_ScreenShot.png')} />
        </AbsoluteFill>
      </Sequence>


      <Sequence from={5850}>
      <TitleCard title="PERSONALZIED AGENT WEBSITE" BGcolor="#BCD400" GraphicDuration="120"/>
      </Sequence>

      <Sequence from={6098} durationInFrames={300}>
        <AbsoluteFill>
        <Img src={staticFile('CalcScreenShot.png')} />
        </AbsoluteFill>
      </Sequence>

      <Sequence from={6090}>
      <TitleCard title="PROFIT SHARE COMP PLAN" BGcolor="#BCD400" GraphicDuration="120"/>
      </Sequence>

      <Sequence from={6370}>
      <TitleCard title="DESERT NORTH REALTY IS NOT A PROFIT CENTER" BGcolor="#BCD400" GraphicDuration="140"/>
      </Sequence>

      <Sequence from={7100}>
    
        <absoluteFill
        style={{
          backgroundColor: 'white',
          width: '100%',
          height: '100%',
        }}
        >
          <div className='center' style={{
            backgroundColor: 'transparent',
            height: '100%',
            transform: `scale(${agentInfoScale})`,
          }}>
          <AgentInfo />
          </div>

        </absoluteFill>


      </Sequence>

      <Sequence from={6990}>
      <TitleCard title={agentBold} BGcolor="#BCD400" GraphicDuration="135"/>
      </Sequence>

    </>
  );
};
